// App.js

import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import NotFound from './components/NotFound';
import Navbar from './components/Navbar';
import Footer2 from './components/Footer2';
import Home from './pages/Home';
import Technical from './pages/Technical';
import About from './pages/About';
import PartnerDesc from './pages/PartnerDesc';
import MCPServerPage from './pages/MCPServerPage';
import { NavbarData } from './data/data.source';
import { FooterData1 } from './data/data.source';

// scroll to top on route change
const ScrollToTop = ({ children }) => {
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return children;
};

function App() {
  return (
    <div>
      <Router>
        <Navbar data={NavbarData} />
        <ScrollToTop>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/tec" element={<Technical />} />
            <Route exact path="/home" element={<Home />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path="/partner" element={<PartnerDesc />} />
            <Route exact path="/mcp-server" element={<MCPServerPage />} />
            <Route element={<NotFound />} />
          </Routes>
        </ScrollToTop>
      </Router>
      <Footer2 data={FooterData1} />
    </div>
  );
}

export default App;
